import React from "react";

const toPercent = (filled, required) => {
    if (!required) return 0;
    return Math.round((filled / required) * 100);
};

const NON_CONTENT_SECTIONS = new Set(['SUBMIT']);

export const sectionsProgress = (sections) => {
    const safe = Array.isArray(sections) ? sections : [];
    const content = safe.filter((s) => !NON_CONTENT_SECTIONS.has(s.name));
    let filled = 0;
    let required = 0;
    content.forEach((s) => {
        if (typeof s.required === 'number' && typeof s.filled === 'number') {
            required += s.required;
            filled += s.filled;
        } else {
            required += 1;
            if (s.complete) filled += 1;
        }
    });
    return { filled, required, percent: toPercent(filled, required) };
};

export const calculatePercentFromSections = (sections) => sectionsProgress(sections).percent;

const rsTypeToGenerator = {};
const registerGenerator = (rsType, fn) => { rsTypeToGenerator[rsType] = fn; };

const loadGenerator = (rsType) => {
    if (rsTypeToGenerator[rsType]) return rsTypeToGenerator[rsType];
    try {
        if (rsType === 1) registerGenerator(1, require('../Residential/RSheetsResidentialLogic').generateSections);
        else if (rsType === 2) registerGenerator(2, require('../Lease/RSheetsLeaseLogic').generateSections);
        else if (rsType === 3) registerGenerator(3, require('../Sublease/RSheetsSubleaseLogic').generateSections);
        else if (rsType === 4) registerGenerator(4, require('../Sale/RSheetsSaleLogic').generateSections);
        else if (rsType === 5) registerGenerator(5, require('../TenantRep/RSheetsTenantRepLogic').generateSections);
        else if (rsType === 6) registerGenerator(6, require('../Consulting/RSheetsConsultingLogic').generateSections);
        else if (rsType === 7) registerGenerator(7, require('../Commission/RSheetsCommissionLogic').generateSections);
        else if (rsType === 8) registerGenerator(8, require('../NoListing/RSheetsNoListingLogic').generateSections);
        else if (rsType === 9) registerGenerator(9, require('../LeaseAssignmentFee/RSheetsLeaseAssignmentFeeLogic').generateSections);
    } catch (e) {}
    return rsTypeToGenerator[rsType];
};

export const calculatePercentForRsRow = (rs) => {
    if (!rs) return 0;
    const gen = loadGenerator(rs.type);
    if (!gen) return 0;
    try {
        const sections = gen(rs.json_data || {}, [], null, []);
        return sectionsProgress(sections).percent;
    } catch (e) {
        return 0;
    }
};

const PercentCompleteBanner = (props) => {
    const { sections } = props;
    const { filled, required, percent } = sectionsProgress(sections);
    return (
        <div style={{
            background: '#f5f5f5',
            border: '1px solid #e0e0e0',
            borderRadius: 4,
            padding: '8px 14px',
            marginBottom: 12,
            display: 'flex',
            alignItems: 'center',
            gap: 12
        }}>
            <div style={{ fontWeight: 'bold', minWidth: 110 }}>
                {percent}% Complete
            </div>
            <div style={{ fontSize: 12, color: '#555', minWidth: 100 }}>
                {filled} / {required} fields
            </div>
            <div style={{ flex: 1, height: 8, background: '#e0e0e0', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${percent}%`, height: '100%', background: '#888', transition: 'width 0.3s' }} />
            </div>
        </div>
    );
};

export default PercentCompleteBanner;
